<template>
    <div>
        <v-dialog v-model="_showDialog" persistent max-width="700">
            <v-card>
                <v-card-title class="headline">
                    Mejorar escritura
                </v-card-title>

                <v-card-text>
                    <v-textarea 
                        v-model="_textToImprove" 
                        class="mx-2 mb-4" 
                        label="Original" 
                        rows="4" 
                        no-resize
                        :value="_textToImprove" 
                        hide-details  
                    ></v-textarea>
                    <div class="d-flex align-center justify-space-between mb-2">
                        <ArdiTypeWriter text="¡Por supuesto! Aquí tienes mi propuesta 👇🏼🤓:" />
                        <v-btn 
                            @click="handleImproveWriting" variant="text" icon 
                            class="justify-items-end" color="primary" density="compact" 
                            :disabled="loading || isTyping"
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </div>
                    <ArdiChunkWriting v-if="!loading" :text="improvedText" :isTyping="isTyping" />
                    <v-skeleton-loader type="paragraph" v-else></v-skeleton-loader>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="_showDialog = false">
                        Cancelar
                    </v-btn>

                    <v-btn color="success" text @click="handleAccept" :disabled="!improvedText.length || isTyping || loading">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ArdiTypeWriter from '@/components/ArdiTypeWriter'
import ArdiChunkWriting from '@/components/ArdiChunkWriting'
import { improveWriting } from '@/api/textActions'

export default {
    name: "ArdiImproveWriting",
    components: {
        ArdiTypeWriter,
        ArdiChunkWriting
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true
        },
        textToImprove: {
            type: String,
            required: true
        }
    },
    data: () => ({
        loading: false,
        improvedText: '',
        isTyping: false
    }),
    methods: {
        async handleImproveWriting() {
            this.loading = true
            this.improvedText = ''
            let params = {
                type: 'improve_writing',
                text: this.textToImprove
            }
            this.isTyping = true
            await improveWriting(params, (chunk) => {
                this.loading = false
                this.improvedText += chunk.delta
            })
            this.isTyping = false
        },
        handleAccept() {
            this.$emit('accept', this.improvedText)
            this._showDialog = false
        }

    },
    mounted() {
        this.handleImproveWriting()
    },
    computed: {
        _showDialog: {
            get() {
                return this.showDialog;
            },

            set(value) {
                this.$emit('update:showDialog', value);
            }
        },
        _textToImprove: {
            get() {
                return this.textToImprove;
            },

            set(value) {
                this.$emit('update:textToImprove', value);
            }
        }
    }
};
</script>